import * as types from './types'
import storage from '@/Plugins/storage'
import store from '@/Store'

export default {
  [types.SET_PAGER](state, data) {
    switch (data.name) {
      case 'orderBy': {
        state.pager.orderBy = data.value
        break
      }
      case 'sortBy': {
        state.pager.sortBy = data.value
        break
      }
      case 'search': {
        state.pager.search = data.value
        break
      }
      case 'page': {
        state.pager.page = data.value
        break
      }
      case 'pageSize': {
        state.pager.pageSize = data.value
        break
      }
    }
    storage.session.setItem(types.STORE_PAGER, JSON.stringify(state.pager))
  },
  [types.SET_TOKEN](state, token) {
    state.token = token
    storage.session.setItem(types.STORE_TOKEN, JSON.stringify(state.token))
  },
  [types.SET_LOGOUT](state, token) {
    let pager = {
      pageSize: 10,
      orderBy: 'asc',
      sortBy: null,
      search: null,
      total: 0,
      page: 1,
      pages: 1,
    }
    state.token = null
    storage.session.setItem(types.STORE_TOKEN, JSON.stringify(null))
    state.profile = null
    storage.session.setItem(types.STORE_PROFILE, JSON.stringify(null))
    storage.session.setItem(types.STORE_PAGER_ORG, JSON.stringify(pager))
    storage.session.setItem(types.STORE_PAGER_CARDIO, JSON.stringify(pager))
  },
  [types.SET_PROFILE](state, profile) {
    state.profile = profile
    storage.session.setItem(types.STORE_PROFILE, JSON.stringify(profile))
  },
  [types.RESET_USER](state) {
    state.user = JSON.parse(JSON.stringify(state.default))
  },
  [types.SET_CHECKED](state, data) {
    for (let user of state.users) {
      if (user.id === data.id) {
        user.isChecked = data.isChecked
      }
    }
    state.isChecked = false
    for (let user of state.users) {
      if (user.isChecked) {
        state.isChecked = true
        break
      }
    }
  },
  [types.SET_FOUND_USERS](state, data) {
    state.foundUsers = []
    if (data !== undefined && data !== null) {
      state.foundUsers = data.data
    }
  },
  [types.SET_USERS](state, data) {
    state.users = []
    state.isChecked = false
    if (data !== undefined && data !== null) {
      if (data.data !== undefined && data.data !== null) {
        for (let item of data.data) {
          item.isChecked = false
        }
      }
      state.users = data.data
      state.pager.page = data.current_page
      state.pager.pages = data.last_page
      state.pager.total = data.total
    }
  },
  [types.SET_USER_HIGHLIGHT](state, data) {
    state.user = null
    if (data !== undefined && data !== null) {
      state.user = data
    }
  },
  [types.SET_USER](state, data) {
    state.user = null
    if (data !== undefined && data !== null) {
      state.user = data
      state.user.detail.password = ''
      state.user.detail.password2 = ''
      state.user.organizations.forEach((element) => {
        element.isSelected = false
        element.isHover = false
        element.isCurrent = false
        if (element.id === state.user.detail.organization_id) {
          element.isCurrent = true
        }
      })
      state.user.selectedOrganization = null
    }
  },
  [types.UPDATE_USER_DATA](state, data) {
    if (data !== undefined && data !== null) {
      store.dispatch('usercardio/updateMemberData', data)
    }
  },
  [types.SET_HOVER](state, data) {
    state.user.organizations.forEach((element) => {
      element.isHover = false
      if (element.id === data.id) {
        element.isHover = true
      }
    })
  },
  [types.SET_SELECTED](state, data) {
    state.user.selectedOrganization = data.id
    state.user.organizations.forEach((organization) => {
      organization.isSelected = false
      if (organization.id === data.id) {
        organization.isSelected = true
        state.user.roles.forEach((role) => {
          role.isSelected = false
          if (role.id === organization.role_id) {
            role.isSelected = true
          }
        })
      }
    })
  },
  [types.SET_CURRENT](state, data) {
    state.user.organizations.forEach((element) => {
      element.isCurrent = false
      if (element.id === data.id) {
        element.isCurrent = true
        state.user.detail.organization_id = element.id
        state.user.detail.organization = element.OrgName
      }
    })
  },
  [types.SET_PASSWORD](state) {
    state.user.detail.password = ''
    state.user.detail.password2 = ''
  },
  [types.SET_USER_ORGANIZATIONS](state, data) {
    state.user.organizations = data
  },
  [types.SET_USER_ROLES](state, data) {
    if (state.user !== undefined && state.user !== null) {
      state.user.roles = data
    } else {
      state.roles = []
      data.forEach((element) => {
        state.roles.push({
          name: element.label,
          value: element.id,
        })
      })
    }
  },
  [types.SET_ROLES](state, data) {
    state.user.roles.forEach((role) => {
      role.isSelected = false
    })
    data.forEach((element) => {
      state.user.roles.forEach((role) => {
        if (role.id === element) {
          role.isSelected = true
        }
      })
    })
  },
  [types.SET_USER_DATA](state, data) {
    switch (data.name) {
      case 'firstname': {
        state.user.detail.firstName = data.value
        break
      }
      case 'lastname': {
        state.user.detail.lastName = data.value
        break
      }
      case 'nickname': {
        state.user.detail.nickName = data.value
        break
      }
      case 'email': {
        state.user.detail.email = data.value
        break
      }
      case 'gender': {
        state.user.detail.gender = data.value
        break
      }
      case 'birthday': {
        state.user.detail.birthday = data.value
        break
      }
      case 'address1': {
        state.user.detail.address1 = data.value
        break
      }
      case 'address2': {
        state.user.detail.address2 = data.value
        break
      }
      case 'city': {
        state.user.detail.city = data.value
        break
      }
      case 'state': {
        state.user.detail.state = data.value
        break
      }
      case 'zipcode': {
        state.user.detail.zipcode = data.value
        break
      }
      case 'phoneCell': {
        state.user.detail.phoneCell = data.value
        break
      }
      case 'isAllowTextMessages': {
        state.user.detail.isAllowTextMessages = data.value
        break
      }
      case 'phoneDay': {
        state.user.detail.phoneDay = data.value
        break
      }
      case 'phoneHome': {
        state.user.detail.phoneHome = data.value
        break
      }
      case 'timezone': {
        state.user.detail.timezone_id = data.value
        break
      }
      case 'organization': {
        state.user.detail.organization_id = data.value
        break
      }
      case 'password': {
        state.user.detail.password = data.value
        break
      }
      case 'password2': {
        state.user.detail.password2 = data.value
        break
      }
      case 'organization_id': {
        state.user.detail.organization_id = data.value
        state.user.detail.currentorganization_id = data.value
        break
      }
      case 'avatar': {
        state.user.detail.avatar = data.value
        break
      }
      case 'isNoEmailAfterClassRecap': {
        state.user.detail.isNoEmailAfterClassRecap = data.value
        break
      }
      case 'isNoEmailMidweekRecap': {
        state.user.detail.isNoEmailMidweekRecap = data.value
        break
      }
      case 'isNoEmailWeeklyRecap': {
        state.user.detail.isNoEmailWeeklyRecap = data.value
        break
      }
    }
  },
  [types.RESET_USER_NOTE](state) {
    state.note = JSON.parse(JSON.stringify(state.defaultNote))
  },
  [types.SET_USER_NOTE](state, id) {
    state.note = JSON.parse(JSON.stringify(state.defaultNote))
    if (state.notes) {
      let found = state.notes.find((x) => parseInt(x.id) === parseInt(id))
      if (found) {
        state.note = JSON.parse(JSON.stringify(found))
      }
    }
  },
  [types.SET_USER_NOTES](state, data) {
    state.notes = []
    if (data) {
      state.notes = data
    }
  },
  [types.SET_USER_NOTE_DATA](state, data) {
    switch (data.name) {
      case 'user_id': {
        state.note.user_id = data.value
        break
      }
      case 'subject': {
        state.note.subject = data.value
        break
      }
      case 'note': {
        state.note.note = data.value
        break
      }
      case 'priority': {
        state.note.priority = data.value
        break
      }
      case 'is_complete': {
        state.note.is_complete = data.value
        break
      }
      case 'attachments': {
        state.note.attachments = data.value
        break
      }
    }
  },
}
